const AB_EXPERIMENT_SIGN_DATA_KEY = "AB_EXPERIMENT_SIGN_DATA_KEY";

const devConf = {
  app_key: "ABTEST_bd30f5c7-02c7-4bcc-b491-8f5d4dc95e9c",
  app_name: "hb_web_dev",
};

const prodConf = {
  app_key: "ABTEST_eea0a010-f216-4058-b4fb-96397bfac9f8",
  app_name: "hb_web",
};

module.exports = {
  AB_EXPERIMENT_SIGN_DATA_KEY,
  devConf,
  prodConf,
};
